/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Full_Stack_Web_Apps_Work_0_BadgeInputs */

const en_svc_full_stack_web_apps_work_0_badge = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full-stack web app`)
};

const ar_svc_full_stack_web_apps_work_0_badge = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تطبيق ويب متكامل`)
};

const bn_svc_full_stack_web_apps_work_0_badge = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফুল-স্ট্যাক ওয়েব অ্যাপ`)
};

const de_svc_full_stack_web_apps_work_0_badge = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full-Stack-Webanwendung`)
};

const es_svc_full_stack_web_apps_work_0_badge = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicación web completa`)
};

const fr_svc_full_stack_web_apps_work_0_badge = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Application Web complète`)
};

const pt_svc_full_stack_web_apps_work_0_badge = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicativo web full-stack`)
};

const zh_svc_full_stack_web_apps_work_0_badge = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全栈网络应用程序`)
};

const tr_svc_full_stack_web_apps_work_0_badge = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tam yığın web uygulaması`)
};

const ru_svc_full_stack_web_apps_work_0_badge = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полнофункциональное веб-приложение`)
};

const pl_svc_full_stack_web_apps_work_0_badge = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pełna aplikacja internetowa`)
};

/**
* | output |
* | --- |
* | "Full-stack web app" |
*
* @param {Svc_Full_Stack_Web_Apps_Work_0_BadgeInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_full_stack_web_apps_work_0_badge = /** @type {((inputs?: Svc_Full_Stack_Web_Apps_Work_0_BadgeInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Full_Stack_Web_Apps_Work_0_BadgeInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_full_stack_web_apps_work_0_badge(inputs)
	if (locale === "bn") return bn_svc_full_stack_web_apps_work_0_badge(inputs)
	if (locale === "de") return de_svc_full_stack_web_apps_work_0_badge(inputs)
	if (locale === "es") return es_svc_full_stack_web_apps_work_0_badge(inputs)
	if (locale === "fr") return fr_svc_full_stack_web_apps_work_0_badge(inputs)
	if (locale === "pt") return pt_svc_full_stack_web_apps_work_0_badge(inputs)
	if (locale === "zh") return zh_svc_full_stack_web_apps_work_0_badge(inputs)
	if (locale === "tr") return tr_svc_full_stack_web_apps_work_0_badge(inputs)
	if (locale === "ru") return ru_svc_full_stack_web_apps_work_0_badge(inputs)
	if (locale === "pl") return pl_svc_full_stack_web_apps_work_0_badge(inputs)
	return en_svc_full_stack_web_apps_work_0_badge(inputs)
});
export { svc_full_stack_web_apps_work_0_badge as "svc_full-stack-web-apps_work_0_badge" }